import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Pages/Home/index';
import AgentIndex from './Pages/Tickets/AgentIndex';
import TicketSearch from './Pages/Tickets/index';
import User from './Pages/User/index';
import Login from './Pages/User/Login';
import AccessDenied from './Components/Shared/AccessDenied';
import UnAuthorize from './Components/Shared/UnAuthorize';
import Project from './Pages/Project/index';
import Category from './Pages/Category/Index';
import Company from './Pages/Company/index';
import Topic from './Pages/Topic/Index';
import ProjectVersion from './Pages/ProjectVersion/index';
import ReportActivity from './Pages/Report/Activity';
import Conversations from './Pages/Conversation/index';
import TopicShow from './Pages/Topic/Show';
import TopicHome from './Pages/Topic/TopicHome';
import Task from './Pages/Task/index';
import MyTasks from './Pages/Task/MyTasks';
import TaskApproval from './Pages/Task/Approval';
function App() {
  return (


    <BrowserRouter>

      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/AgentIndex" element={<AgentIndex />} />
        <Route path="/Tickets" element={<TicketSearch />} />
        <Route path="/User" element={<User />} />
        <Route path="/home" element={<Home />} />
        <Route path="/AccessDenied" element={<AccessDenied />} />
        <Route path="/UnAuthorize" element={<UnAuthorize />} />
        <Route path="/Project" element={<Project />} />
        <Route path="/Category" element={<Category />} />
        <Route path="/Company" element={<Company />} />
        <Route path="/Topic" element={<Topic />} />
        <Route path="/ProjectVersion" element={<ProjectVersion />} />
        <Route path="/ReportActivity" element={<ReportActivity />} />
        <Route path="/Conversations" element={<Conversations />} />
        <Route path="/TopicHome" element={<TopicHome />} />
        <Route path="/Show/:PId/:TId" element={<TopicShow />} />
        <Route path="/Task" element={<Task />} />
        <Route path="/MyTasks" element={<MyTasks />} />
        <Route path="/TaskApproval" element={<TaskApproval />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
